import { memo } from "react";
import { MenuItem, TextField } from "@mui/material";
import type { ProfessionalOption } from "../hooks/useOrganizationProfessionalOptions";

const ALL_PROFESSIONALS = "";

/** Filtro por profissional da visão clínica ("Todos" = sem filtro). */
export const ProfessionalFilterSelect = memo(function ProfessionalFilterSelect({
  options,
  value,
  onChange,
}: {
  options: ProfessionalOption[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <TextField
      select
      size="small"
      label="Profissional"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      sx={{ minWidth: { xs: "100%", sm: 240 } }}
    >
      <MenuItem value={ALL_PROFESSIONALS}>Todos os profissionais</MenuItem>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
});
